import { SegmentValues } from '@data/queries/experiment/types'

/**
 * Creates a map of boolean flags for each of the important segments.
 *
 * @example { isSegmentA: true, isSegmentB: false }
 */
export const getImportantSegmentValues = (segment: TExperimentSegment): SegmentValues =>
    ({
        isSegmentA: segment === 'A',
        isSegmentB: segment === 'B',
        isSegmentC: segment === 'C',
        isSegmentD: segment === 'D',
    }) as SegmentValues // Compiler does not understand these values as mutually exclusive
